import useRoleAuthentication from "../../../Authentication/hooks/useRoleAuthentication";
import { scholarsMenuItemsEnum } from "./scholarsMenuItemsEnum";
import { useGetScholarsApplicantQueueEntriesQuery, useGetScholarsApplicationDetailsQueryState } from "../../../services/graphql/api";
import { getScholarsApplDetailParams } from "../ScholarsApplicant";
import { SCHOLARS_QUEUE_STATUS } from "../../../util/constants";
import { STUDENT_REQUEST_ACTIONS } from "../../../util/constants";

// Scholars Actions menu items, filtered by (a) the caller's roles and (b) per-item specialCaseFilterFns
// evaluated against extraInfo — mirroring the Honors useActionMenuItems contract. extraInfo currently
// carries ownership: whether the caller owns an active (IN_REVIEW) placement for THIS applicant, which
// gates owner-scoped actions like "Resume Later" (you can only resume an applicant you pulled or that was
// manually assigned to you). Returns { menuItems } for ButtonAndPopupMenu.
const useScholarsActionMenuItems = () => {
    const { roles, user } = useRoleAuthentication();
    const params = getScholarsApplDetailParams();
    const { data } = useGetScholarsApplicationDetailsQueryState(getScholarsApplDetailParams());
    const details = data?.details ?? {};

    const { data: queueEntries = [] } = useGetScholarsApplicantQueueEntriesQuery(
        { applicantEmployeeId: params?.applicantEmployeeId, term: params?.term },
        { skip: !params?.applicantEmployeeId }
    );

    // The caller owns this applicant when they hold an IN_REVIEW placement for them (pulled from the queue
    // or manually assigned to them). reviewerEmployeeId is the placement owner (has504 projection).
    const callerEmployeeId = user?.osuid;
    const isOwnInProgress = !!callerEmployeeId && (queueEntries ?? []).some(
        (e) => e?.status === SCHOLARS_QUEUE_STATUS.IN_REVIEW.KEY && e?.reviewerEmployeeId === callerEmployeeId
    );

    const extraInfo = {
        isOwnInProgress,
        studentRequestIsActive: details.administratorDetails?.studentRequestIsActive,
        withdrawRequested: details.administratorDetails?.studentRequestType === STUDENT_REQUEST_ACTIONS.WITHDRAW.label,
        programChangeRequested: details.administratorDetails?.studentRequestType === STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.label,
    };

    const menuItems = scholarsMenuItemsEnum.filter(menuItem => {
        if (menuItem.disabled) { return false; } // Feature flag for removing menu items

        const rolesAllowed = menuItem.roles ?? [];
        if (!rolesAllowed.some(role => roles?.includes(role))) { return false; }

        const filterFns = menuItem.specialCaseFilterFns ?? [];
        return filterFns.every(fn => fn(extraInfo));
    });

    return { menuItems };
};

export default useScholarsActionMenuItems;
